import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocuments = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.4118 0) scale(1.4118)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.3 7.3V4.34C13.3 2.99587 13.3 2.32381 13.0384 1.81042C12.8083 1.35883 12.4412 0.99168 11.9896 0.761584C11.4762 0.5 10.8041 0.5 9.46 0.5H4.34C2.99587 0.5 2.32381 0.5 1.81042 0.761584C1.35883 0.99168 0.99168 1.35883 0.761584 1.81042C0.5 2.32381 0.5 2.99587 0.5 4.34V12.66C0.5 14.0041 0.5 14.6762 0.761584 15.1896C0.99168 15.6412 1.35883 16.0083 1.81042 16.2384C2.32381 16.5 2.99587 16.5 4.34 16.5H6.9M8.5 7.7H3.7M5.3 10.9H3.7M10.1 4.5H3.7M11.7 15.7V10.9M9.3 13.3H14.1",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgDocuments);
export default ForwardRef;
